import { render, staticRenderFns } from "./TheInsumo.vue?vue&type=template&id=54f31280&"
import script from "./TheInsumo.vue?vue&type=script&lang=js&"
export * from "./TheInsumo.vue?vue&type=script&lang=js&"
import style0 from "./TheInsumo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports